"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { DOWNLOAD_APP_URL } from "@/lib/links";
export default function ReadyToStartTracking() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="1269" id="ready-to-start-tracking" className="relative z-10 text-foreground overflow-hidden">
      {/* Hero content area with owner's finished hero image edge-to-edge */}
      <div className="relative w-full">
        <h1 className="sr-only">Manage Your Card Collection</h1>

        <div ref={contentRef} className={`w-full transition-all duration-700 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {/* Owner's full finished hero image (16:9, ~1920x1080) */}
          <div className="relative w-full overflow-hidden [container-type:inline-size]">
            <img src="https://getondeckapp.com/wp-content/uploads/2026/11/hero-no-button-1.jpg" alt="On Deck app: Manage Your Card Collection. Track your holdings and total value." loading="eager" className="w-full h-auto block" style={{
            maskImage: "linear-gradient(to bottom, rgb(0 0 0) 0%, rgb(0 0 0) 70%, rgb(0 0 0 / 0.85) 78%, rgb(0 0 0 / 0.55) 86%, rgb(0 0 0 / 0.25) 93%, transparent 100%)",
            WebkitMaskImage: "linear-gradient(to bottom, rgb(0 0 0) 0%, rgb(0 0 0) 70%, rgb(0 0 0 / 0.85) 78%, rgb(0 0 0 / 0.55) 86%, rgb(0 0 0 / 0.25) 93%, transparent 100%)"
          }} />
            <Link to={DOWNLOAD_APP_URL} newTab className="absolute left-[7.8%] top-[63%] inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground font-default font-semibold tracking-normal shadow-sm hover:opacity-90 active:scale-[0.98] transition-all" style={{
            fontSize: "clamp(0.6875rem, 1.4cqw, 1.125rem)",
            paddingLeft: "clamp(0.875rem, 2.6cqw, 2.25rem)",
            paddingRight: "clamp(0.875rem, 2.6cqw, 2.25rem)",
            paddingTop: "clamp(0.4rem, 1.1cqw, 1rem)",
            paddingBottom: "clamp(0.4rem, 1.1cqw, 1rem)",
            minHeight: "clamp(28px, 4cqw, 52px)"
          }}>
              Download Now
            </Link>
          </div>
        </div>
      </div>
    </section>;
}